/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @type {Array} The array filled with two-part transition words.
 */
export default [ [ "både", "og" ], [ "enten", "eller" ], [ "verken", "eller" ], [ "jo", "dess" ], [ "dess", "dess" ], [ "jo", "desto" ],
	[ "ikke bare", "men" ], [ "ikke bare", "også" ],
];

